export default "__VITE_ASSET__DUQfF_tM__"